import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

type LoadingState = {
  isLoading: boolean;
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState: { isLoading: false } as LoadingState,
  reducers: {
    setIsLoading: (
      state,
      { payload: { isLoading } }: PayloadAction<{ isLoading: boolean }>
    ) => {
      state.isLoading = isLoading;
    },
  },
});

export const { setIsLoading } = loadingSlice.actions;

export default loadingSlice.reducer;

export const selectIsLoading = (state: RootState) => state.loading.isLoading;
